export default __webpack_public_path__ + "img/img/norton.9e98ff80.svg";